const en = {
  ourProjects: 'Our Projects',
  usernameIsTaken: 'Username is already taken. Please try another one.',
  settingsTxt: 'Settings',
  myProfileTxt: 'My Profile',
  bobName: 'Bob - AI Assistant',
  awarenessTest: 'Awareness Test',
  findSolutions: 'Find solutions for your problems',
  learnAboutUXCore: 'Learn human thinking patterns',
  podcast: 'Podcast',
  arcOfSelf: 'Arc of Self',
  arcOfSelfTooltip: 'A recursive theory of identity',
  done: 'Done',
  usefulLinks: [
    {
      title: '',
      items: [
        {
          title: 'Cognitive biases in education',
          link: '/articles/uxeducation',
        },
      ],
    },
    {
      title: 'UX CORE GUIDE',
      items: [
        {
          title: 'Add your question',
        },
      ],
    },
    {
      title: 'UX CORE PERSONA',
      items: [
        {
          title: 'Introduction Article',
          icon: 'medium-logo',
          link: 'https://medium.com/@alexanyanwolf/creating-user-persona-with-cognitive-biases-and-ux-core-cb5a03a897a9',
          target: '_blank',
          alt: 'Medium.com publishing platform logo',
        },
      ],
    },
    {
      title: '',
      items: [
        {
          title: 'API',
          icon: 'api',
          link: '/uxcore-api',
          target: '',
          alt: 'UX Core API',
        },
      ],
    },
  ],
};

export default en;
